import React, { useState } from "react";
import "assets/scss/pages/_DesignSystemComponents.scss";
import DesignSystemLayout from "components/DesignSystemPage/DesignSystemLayout";
import { useParams } from "react-router-dom";
import { getComponentsSideData } from "assets/data/sideTabData";
import { useGlobalContext } from "context/GlobalContext";

import PreviewModalComponent from "components/DesignSystemPage/ModalComponent/PreviewModalComponent";
import UsageModalComponent from "components/DesignSystemPage/ModalComponent/UsageModalComponent";
import TokenTableComponent from "components/Common/TokenTableComponent/TokenTableComponent";
import { modalTokenTabData } from "assets/data/tokenTabData";


const ModalComponents = () => {
  const { id } = useParams();
  const { designSystemMeta, designSystem } = useGlobalContext();

  const componentName = "modal";
  const componentKey = `Component/${componentName}`;
  const componentData = designSystem[componentKey];
  const tokenTableData = modalTokenTabData(componentData, componentName);

  const tabData = ["Default"];
  const tabs = ["Preview", "Usage", "Tokens"];

  const [activeTab, setActiveTab] = useState(0);
  const [selectedTab, setSelectedTab] = useState(0);

  const handleTabClick = (index) => {
    setActiveTab(index);
  };

  const bannerData = {
    heading: "Modal",
    description:
      "Add, replace, generate colors which makes your design looks awesome!",
    bannerImage: designSystemMeta.banner_url,
  };

  const renderContent = () => {
    switch (selectedTab) {
      case 0:
        return (
          <PreviewModalComponent
            tabData={tabData}
            activeTab={activeTab}
            setSelectedTab={setSelectedTab}
            handleTabClick={handleTabClick}
          />
        );
      case 1:
        return <UsageModalComponent />;
      case 2:
        // return (
        //   <TokenTableComponent
        //     tabData={modalTabData}
        //     tokenTableData={tokenTableData}
        //   />
        // );
         return <TokenTableComponent tokenTableData={tokenTableData} />;
      default:
        return null;
    }
  };
  return (
    <DesignSystemLayout
      bannerData={bannerData}
      selectedTab={selectedTab}
      setSelectedTab={setSelectedTab}
      tabs={tabs}
      sideTabs={getComponentsSideData(id)}
      title='Components'
    >
      {renderContent()}
    </DesignSystemLayout>
  );
};

export default ModalComponents;
